export default __webpack_public_path__ + "static/media/bg_partenaires.166aacc1.jpeg";